export default __webpack_public_path__ + "static/media/changePassword.0caf865c.svg";